import React, { useContext, useMemo, useState } from "react";
import { Card as SemanticCard, Header, Modal, List } from "semantic-ui-react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import HomePageContext from "./HomePageContext";
import constants from "../../../common/constants";


const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

function Cards() {

  const ctx = useContext(HomePageContext);
  const history = useHistory();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalCases, setModalCases] = useState<any[]>([]);

  const handleOpenInstructionModal = (stateKey: string, title: string) => {
    const cases = ctx.instructionCasesByState?.[stateKey] || [];
    setModalTitle(`${title} - Instruction Cases`);
    setModalCases(cases);
    setModalOpen(true);
  };

  return (
    <>
      <Header as="h4">Cases</Header>
      <div style={{ overflow: "hidden", width: "100%" }}>
        <SemanticCard.Group itemsPerRow={3} style={{ margin: 0 }}>
        <Card
          title={"Pending Generation"}
          count={ctx.count.initiated}
          instructionCount={ctx.intructionCount.initiated}
          onClick={() => ctx.navigate(constants.caseStates.initiated)}
          onClickInstruction={() => handleOpenInstructionModal(constants.caseStates.initiated, "Pending Generation")}
        />

        <Card
          title={"Pending Allocation"}
          count={ctx.count.generated}
          instructionCount={ctx.intructionCount.generated}
          onClick={() => ctx.navigate(constants.caseStates.generated)}
          onClickInstruction={() => handleOpenInstructionModal(constants.caseStates.generated, "Pending Allocation")}
        />

        <Card
          title={"Open"}
          count={ctx.count.open}
          instructionCount={ctx.intructionCount.open}
          onClick={() => ctx.navigate(constants.caseStates.open)}
          onClickInstruction={() => handleOpenInstructionModal(constants.caseStates.open, "Open")}
        />

        <Card
          title={"Pending Report"}
          count={ctx.count.reportwriting}
          instructionCount={ctx.intructionCount.reportwriting}
          onClick={() => ctx.navigate(constants.caseStates.report)}
          onClickInstruction={() => handleOpenInstructionModal(constants.caseStates.report, "Pending Report")}
        />


        <Card
          title={"Pushback Claim Analyst"}
          count={ctx.count.pushbackCA}
          instructionCount={ctx.intructionCount.pushbackCA}
          onClick={() => ctx.navigate(constants.caseStates.pushbackCA)}
          onClickInstruction={() => handleOpenInstructionModal(constants.caseStates.pushbackCA, "Pushback Claim Analyst")}
        />

        <Card
          title={"Pushback Report Writing"}
          count={ctx.count.pushbackRW}
          instructionCount={ctx.intructionCount.pushbackRW}
          onClick={() => ctx.navigate(constants.caseStates.pushbackRW)}
          onClickInstruction={() => handleOpenInstructionModal(constants.caseStates.pushbackRW, "Pushback Report Writing")}
        />

        <Card
          title={"Reinvestigation"}
          count={ctx.count.reinvestigate}
          instructionCount={ctx.intructionCount.reinvestigate}
          onClick={() => ctx.navigate(constants.caseStates.reinvestigate)}
          onClickInstruction={() => handleOpenInstructionModal(constants.caseStates.reinvestigate, "Reinvestigation")}
        />

        <Card
          title={"Pending QC"}
          count={ctx.count.fold}
          instructionCount={ctx.intructionCount.fold}
          onClick={() => ctx.navigate(constants.caseStates.fold)}
          onClickInstruction={() => handleOpenInstructionModal(constants.caseStates.fold, "Pending QC")}
        />

        <Card
          title={"Pending Closure"}
          count={ctx.count.checked}
          instructionCount={ctx.intructionCount.checked}
          onClick={() => ctx.navigate(constants.caseStates.checked)}
          onClickInstruction={() => handleOpenInstructionModal(constants.caseStates.checked, "Pending Closure")}
        />

        {/* <Card
          title={"Pushed Back"}
          count={ctx.count.checked}
          onClick={() => ctx.navigate(constants.caseStates.pushedback)}
        /> */}
      </SemanticCard.Group>
      </div>
      <Modal open={modalOpen} onClose={() => setModalOpen(false)} size="small">
        <Modal.Header>{modalTitle}</Modal.Header>
        <Modal.Content scrolling>
          {modalCases.length === 0 ? (
            <div>No instruction cases.</div>
          ) : (
            <List divided relaxed>
              {modalCases.map((c: any) => (
                <List.Item key={c._id}>
                  <List.Icon name="folder open" size="large" verticalAlign="middle" />
                  <List.Content>
                    <List.Header>
                      <a
                        style={{ cursor: "pointer", textDecoration: "underline" }}
                        onClick={() => history.push(`/case/view/${c._id}`)}
                      >
                        {c.claim_number || c._id}
                      </a>
                    </List.Header>
                    <List.Description>
                      {c.case_type_name || ''} {c.case_state ? ` - ${c.case_state}` : ''}
                    </List.Description>
                  </List.Content>
                </List.Item>
              ))}
            </List>
          )}
        </Modal.Content>
      </Modal>
    </>
  );
}

    function Card({ title, count, instructionCount, onClick, onClickInstruction }: CardProps) {
      return (

        <SemanticCard
        onClick={onClick}
        style={{
          backgroundColor: "#1221d6",
          color: "white",
          height: "100px",
          textAlign: "center",
          position: "relative",
          overflow: "visible",
          borderRadius: 10,
        }}
      >
        <span className="head-bell">
        <span
      style={{
        position: "absolute",
        top: "8px",          
        right: "8px",         
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "30px",
        height: "30px",
        borderRadius: "50%",
        backgroundColor: "white",
        color: "#1221d6",
        fontWeight: "bold",
        fontSize: "14px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.2)", 
      }}
    >
      <span onClick={(e) => { e.stopPropagation(); onClickInstruction && onClickInstruction(); }}>
        {instructionCount}
      </span>
    </span>


    </span>

  
    <SemanticCard.Content>
      <SemanticCard.Header
        style={{ backgroundColor: "#1221d6", color: "white" }}
      >
        {title}
      </SemanticCard.Header>
  
        <SemanticCard.Meta
        style={{
          backgroundColor: "#1221d6",
          color: "white",
          marginTop: "8px",
        }}
      >
        <span
          // style={{
          //   display: "inline-flex",
          //   alignItems: "center",
          //   justifyContent: "center",
          //   width: "30px",
          //   height: "30px",
          //   borderRadius: "50%",
          //   backgroundColor: "white",
          //   color: "#1221d6",
          //   fontWeight: "bold",
          //   fontSize: "14px",
          // }}
        >
          {count}
        </span>
      </SemanticCard.Meta>

    </SemanticCard.Content>
  </SemanticCard>
  

  );
}



interface CardProps {
  title: string;
  count: string;
  instructionCount: any
  onClick(): void;
  onClickInstruction?(): void;
}

export default Cards;